/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TrackingInputs */

const vi_nav_tracking = /** @type {(inputs: Nav_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi đội xe`)
};

/**

* @param {Nav_TrackingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tracking = /** @type {((inputs?: Nav_TrackingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TrackingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tracking(inputs)
});